<form action="" class="widget-search__form">
    <input class="widget-search__input" type="search" placeholder="Blog search...">
    <button class="widget-search__button"><app-icon icon="search-20"></app-icon></button>
    <div class="widget-search__field"></div>
</form>
